import React from 'react';
import { ModalHeader as BootstrapModalHeader } from 'reactstrap';
import PropTypes from 'prop-types';

const ModalHeader = ({
  tag,
  toggle,
  children,
  ...props
}) => (
  <BootstrapModalHeader
    tag={tag}
    toggle={toggle}
    {...props}
  >
    {children}
  </BootstrapModalHeader>
);

ModalHeader.propTypes = {
  children: PropTypes.node,
  tag: PropTypes.string,
  toggle: PropTypes.func,
};

ModalHeader.defaultProps = {
  children: null,
  tag: 'h1',
  toggle: Function.prototype
};

export default ModalHeader;
